import(/* webpackMode: "eager" */ "/home/tsagi/build/prod/web-dist/node_modules/bootstrap/dist/css/bootstrap.min.css");
;
import(/* webpackMode: "eager" */ "/home/tsagi/build/prod/web-dist/node_modules/aos/dist/aos.css");
;
import(/* webpackMode: "eager", webpackExports: ["ConsentProvider"] */ "/home/tsagi/build/prod/web-dist/providers/ConsentProvider.tsx");
;
import(/* webpackMode: "eager" */ "/home/tsagi/build/prod/web-dist/src/assets/css/vendors.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/tsagi/build/prod/web-dist/src/components/consent/ConsentBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/tsagi/build/prod/web-dist/src/components/gtm/Gtm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/tsagi/build/prod/web-dist/src/components/layout/TemporaryNotice.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/tsagi/build/prod/web-dist/src/components/layout/Theme.tsx");
